module.exports = __webpack_public_path__ + "img/invitBg.aa0a98e7.png";